import React from "react";

const ContactIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="none"
    viewBox="0 0 21 21"
  >
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M16.625 9.125c0-2.756-2.238-5-5-5M19.75 8.5c0-4.138-3.363-7.5-7.5-7.5M4.125 1L1.344 3.469l-.02.018C.07 4.75 2.563 9.294 6.963 13.695s9.044 7 10.3 5.737l.02-.018L19.75 16.6l-4.375-3.75-3.125 1.9L6 8.5l1.894-3.125L4.124 1z"
    ></path>
  </svg>
);

export default ContactIcon;



// WEBPACK FOOTER //
// ./src/icons/ContactIcon.jsx